import axios from 'axios';

export const PlatformService = {
  GetPlatformsOfTheProducts: async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/product/platforms`,
    );
    return response;
  },
};
